"use client";

import { X } from 'lucide-react';
import { Button } from '@/components/ui';
import { useLocalStorage } from 'usehooks-ts';
import { useEffect, useState } from 'react';

export function Attribution() {
  // Local state for initial render (don't show before checking localStorage)
  const [shouldRender, setShouldRender] = useState(false);
  // Track if user has dismissed the attribution
  const [isDismissed, setIsDismissed] = useLocalStorage('attribution-dismissed', false);

  // After mount, check if we should show the attribution
  useEffect(() => {
    setShouldRender(true);
  }, []);

  // Don't render anything on first render or if dismissed
  if (!shouldRender || isDismissed) return null;

  return (
    <div className="fixed bottom-4 left-4 z-50 bg-background/95 backdrop-blur-sm border rounded-lg px-3 py-2 shadow-lg flex items-center gap-2">
      <a
        href="https://x.com/scottpaulin"
        target="_blank"
        rel="noopener noreferrer nofollow"
        className="text-sm text-muted-foreground hover:text-foreground transition-colors"
      >
        by @scottpaulin
      </a>
      <Button
        variant="ghost"
        size="icon"
        className="h-6 w-6"
        onClick={() => setIsDismissed(true)}
      >
        <X className="h-4 w-4" />
        <span className="sr-only">Dismiss</span>
      </Button>
    </div>
  );
} 